import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-intro-page',
    templateUrl: './intro-page.component.html',
    styleUrls: ['./intro-page.component.scss'],
    standalone: false
})
export class IntroPageComponent implements OnInit, OnChanges {
  @Input() data: any = null;
  @Input() showTourLink: boolean = false;
  @Input() moduleName: string = '';
  @Input() isModalView: boolean = false; 
  @Input() moduleKey!: string; 

  sectionsToRender: any[] = [];
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    console.log('Changes detected:', this.data);
  }

  ngOnInit(): void {
    console.log(this.data, 'data printing in ngOninit of intro-page')
  console.log('VideoCard moduleName:', this.moduleName);
  }
  // get showVideoCardSection(): boolean {
  //   const bigFour = ['assets', 'job-orders', 'preventive-maintenance', 'inventory', 'tasks'];
  //   return bigFour.includes(this.moduleName) && !this.isSubModule;
  // }
 
}
